module.exports = __webpack_public_path__ + "img/42_42.64a1fb2f.png";